import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  DepositsChartByAccountId_accountsCharts,
  DepositsChartByAccountId_accountsChartsVariables
} from '../../../_generated/DepositsChartByAccountId_accountsCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query DepositsChartByAccountId_accountsCharts($id: ID!, $precision: Precision!) {
  charts {
    byAccountId(id: $id) {
      id: accountId
      deposits(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = DepositsChartByAccountId_accountsCharts
export type V = DepositsChartByAccountId_accountsChartsVariables
export type R = Q['charts']['byAccountId']['deposits']

export const parseData = (data: Q): R => {
  return get(data, p => p.charts.byAccountId.deposits)
}

export function Use(accountId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: accountId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
